import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UsuarioDTO } from 'utils/models/types';

export interface AuthState {
  usuario: UsuarioDTO | null;
  redirectPath: string | null;
  status: 'idle' | 'succeeded' | 'failed';
  authError: string | null;
  recienLogueado: boolean;
  recienDeslogueado: boolean;
}

const initialState: AuthState = {
  usuario: null,
  redirectPath: null,
  status: 'idle',
  authError: null,
  recienLogueado: false,
  recienDeslogueado: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setRedirectPath: (state, action: PayloadAction<string | null>) => {
      state.redirectPath = action.payload;
    },
    loginSuccess: (state, action: PayloadAction<UsuarioDTO>) => {
      state.usuario = action.payload;
      state.status = 'succeeded';
      state.redirectPath = null;
      state.recienLogueado = true;
      state.recienDeslogueado = false;
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.authError = action.payload;
      state.status = 'failed';
    },
    logout: state => {
      state.usuario = null;
      state.redirectPath = null;
      state.status = 'idle';
      state.authError = null;
      state.recienLogueado = false;
      state.recienDeslogueado = true;
    },
    resetAuthFlags: state => {
      state.recienLogueado = false;
      state.recienDeslogueado = false;
    },
  },
});

export const { setRedirectPath, loginSuccess, loginFailure, logout, resetAuthFlags } = authSlice.actions;

export default authSlice.reducer;
